import Vue from 'vue'
import Vuex from 'vuex'
import createMutationsSharer from 'vuex-shared-mutations'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

// https://webpack.js.org/guides/dependency-management/#requirecontext
const modulesFiles = require.context('./modules', false, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = (modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')).replace(/-([a-z])/g, g => g[1].toUpperCase())
  // camelCase(modulePath.replace(/^\.\/(.*)\.\w+$/, '$1'));
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules,
  plugins: [createMutationsSharer({
    predicate: [
      'user/SET_IS_A_CAST',
      'account/SET_PHONE_NUMBERS',
      'agent/SET_AGENTS',
      'agent/SET_CURRENT_PAGE',
      'agent/SET_LAST_PAGE',
      'agent/SET_NEXT_PAGE',
      'agent/SET_PREV_PAGE',
      'agent/SET_TOTAL',
      'agent/SET_FROM',
      'agent/SET_TO',
      'phoneAccount/SET_PHONE_ACCOUNT',
      'phoneAccount/SET_CURRENT_PAGE',
      'phoneAccount/SET_LAST_PAGE',
      'phoneAccount/SET_NEXT_PAGE',
      'phoneAccount/SET_PREV_PAGE',
      'phoneAccount/SET_TOTAL',
      'phoneAccount/SET_FROM',
      'phoneAccount/SET_TO',
      'common/SET_IS_CALLING_API',
      'common/SET_IS_CALLING_LIST_STAFF_ACAST_API',
      'common/SET_IS_CALLING_LIST_MESSAGE_ACAST_API',
      'common/SET_HAS_CALLING_TABS',
      'common/SET_HAS_MODAL_NETWORK_ERROR',
      'common/SET_HAS_MODAL_LOG_OFF',
      'reservation/SET_RESERVATION',
      'reservation/REMOVE_RESERVATION',
      'reservation/SET_TASK',
      'reservation/RESET_WORKSPACE',
      'reservation/SET_WORKER',
      'reservation/PUSH_INVALID_RESERVATION',
      'reservation/REMOVE_INVALID_RESERVATION',
      'reservation/RESET_INVALID_RESERVATION',
      'status/SET_STATUSES',
      'twilioDevice/SET_CALL_SID',
      'twilioDevice/SET_CALL_FROM',
      'twilioDevice/SET_CONFERENCE_ID',
      'twilioDevice/SET_CONNECTION',
      'twilioDevice/REMOVE_CONNECTION',
      'twilioDevice/SET_IS_CALLING',
      'worker/SET_WORKER_DATA',
      'callMonitoring/SET_CURRENT_CONFERENCES',
      'callMonitoring/ADD_TO_CURRENT_CONFERENCES',
      'callMonitoring/REMOVE_FROM_CURRENT_CONFERENCES',
      'callMonitoring/SET_COACHING_CONFERENCE'
    ]
  }), createPersistedState()]
})
